import { Buffer } from "buffer";

// function that will format query string to be
// taxonomy=filter,filter&taxonomy=filter,filter
export const FormatFiltersQuery = (selectedFilters) => {
	let filtersQuery = "&";

	selectedFilters.map((taxonomyObj) => {
		filtersQuery = filtersQuery.concat(`${taxonomyObj.taxonomy}=`);

		taxonomyObj.filters.map((filter) => {
			filtersQuery = filtersQuery.concat(`${filter.slug},`);
		});
		filtersQuery = filtersQuery.slice(0, -1);
		filtersQuery = filtersQuery.concat("&");
	});
	filtersQuery = filtersQuery.slice(0, -1);

	return filtersQuery;
};

// this has nothing to do with actual request, what we're doing here is encoding the entire filters object and passing it to the url
// this allows for shareable url and will help us show relevant UI aka selected filters
export const updateUrlParams = (selectedFilters, mediaItem) => {
	let urlParams =
		"?" + Buffer.from(JSON.stringify(selectedFilters)).toString("base64");
	if (mediaItem) {
		urlParams = urlParams + "#" + mediaItem.id;
	}
	return window.history.pushState(null, "", urlParams);
};

// this parse the Buffer string we get from the URL and transform it into the selectedFilters object
export const parseUrlParams = (urlParam) => {
	return JSON.parse(
		Buffer.from(urlParam.replace("?", ""), "base64").toString("ascii")
	);
};